(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["page-helder-consultation"] && !Shopify.designMode) return;
  try {
    
(function() {

  // ── Scroll-reveal ───────────────────────────────────────────
  var reveals = document.querySelectorAll('#helder-landing .hlp-reveal');
  if (reveals.length) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    reveals.forEach(function(el) { observer.observe(el); });
  }

  // ── Smooth scroll ───────────────────────────────────────────
  document.querySelectorAll('#helder-landing a[href^="#"]').forEach(function(a) {
    a.addEventListener('click', function(e) {
      var target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  // ── Form: compile all fields into a formatted email body ────
  var form = document.getElementById('helder-contact-form');
  if (form) {
    form.addEventListener('submit', function() {
      var name     = (form.querySelector('[name="contact[name]"]') || {}).value || '';
      var email    = (form.querySelector('[name="contact[email]"]') || {}).value || '';
      var phone    = (form.querySelector('[name="contact[phone]"]') || {}).value || 'Not provided';
      var location = (form.querySelector('[name="contact[location]"]') || {}).value || 'Not provided';
      var projType = (form.querySelector('[name="contact[project_type]"]') || {}).value || 'Not specified';
      var message  = (form.querySelector('[name="contact[body]"]') || {}).value || '';

      var formatted =
        '━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━\n' +
        '  NEW CONSULTATION REQUEST\n' +
        '  Lighting Centre Direct — Helder Aguiar\n' +
        '━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━\n\n' +
        'CLIENT DETAILS\n' +
        '──────────────\n' +
        'Name:          ' + name + '\n' +
        'Email:         ' + email + '\n' +
        'Phone:         ' + phone + '\n' +
        'Location:      ' + location + '\n\n' +
        'PROJECT DETAILS\n' +
        '───────────────\n' +
        'Project Type:  ' + projType + '\n\n' +
        'About the Project:\n' +
        message + '\n\n' +
        '━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━\n' +
        'Submitted via lightingcentredirect.com/pages/helder-aguiar-lighting-design-consultation\n' +
        '━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━';

      var bodyField = form.querySelector('[name="contact[body]"]');
      if (bodyField) bodyField.value = formatted;
    });
  }

})();

  } catch(e) { console.error(e); }
})();
})();
